import { render, staticRenderFns } from "./merchant-review-search.vue?vue&type=template&id=0d6e863a&scoped=true&"
import script from "./merchant-review-search.vue?vue&type=script&lang=js&"
export * from "./merchant-review-search.vue?vue&type=script&lang=js&"
import style0 from "./merchant-review-search.vue?vue&type=style&index=0&id=0d6e863a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6e863a",
  null
  
)

export default component.exports